export const ENTRY_QUOTES = [
  "在无限的信息里，选择读什么，也是在选择成为什么。",
  "世界不缺少声音，稀缺的是经过判断的注意力。",
  "真正改变判断的，往往不是更多消息，而是一次完整的阅读。",
  "阅读的意义，是让自己的判断比情绪多走一步。",
  "把时间交给那些读完之后，仍会留在心里的东西。",
  "慢一点读，才能更快地抵达自己的判断。",
  "答案会过时，理解世界的方法不会。",
  "好的阅读，不是知道得更多，而是看见得更深。",
  "读到深处，世界会重新显出它的纹理。",
  "注意力投向哪里，时间就会把你带向哪里。",
] as const;

export const ENTRY_QUOTE_STORAGE_KEY = "hiic.entry-quote";

export function selectEntryQuote(
  previous: string | null,
  randomValue = Math.random(),
): string {
  const candidates = ENTRY_QUOTES.filter((quote) => quote !== previous);
  const safeRandom = Number.isFinite(randomValue)
    ? Math.min(Math.max(randomValue, 0), 0.999999)
    : 0;
  return candidates[Math.floor(safeRandom * candidates.length)] ?? ENTRY_QUOTES[0];
}
